import styled from 'styled-components'

import { Color } from '@/service/api/casePage'

type CaseBannerContainerProps = {
  caseBanner: Color['caseBanner']
}
export const CaseBannerContainer = styled.div<CaseBannerContainerProps>`
  display: flex;
  background-color: ${(props) => props.caseBanner?.background || ''};
  width: 100%;
  max-width: 1170px;

  .banner-img {
    object-fit: cover;
  }

  .banner-info {
    display: flex;
    padding: 0 16px;
    margin: 8px 0;
    background-color: ${(props) => props.caseBanner?.backgroundBanner || ''};
    align-items: center;
    justify-content: center;
    width: 100%;

    .title {
      text-align: center;
      color: ${(props) => props.caseBanner?.colorText || '#ffffff'};
    }

    .topics {
      display: none;
      flex-direction: column;
      gap: 24px;
      .topic-title {
        color: ${(props) => props.caseBanner?.colorText || '#ffffff'};
      }
    }
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
    .banner-info {
      padding: 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 32px;
      .topics {
        display: flex;
      }
    }

    .banner-img {
      width: 100%;
    }
  }
`
